import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Introduction from '@components/Introduction';
export const _frontmatter = {
  "name": "Introduction",
  "route": "/",
  "menu": "Introduction"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div style={{
      "textAlign": "center",
      "marginBottom": "64px"
    }}>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "425px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70.71428571428572%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC4klEQVQ4y4WTT2hVRxTGz32xdtuFLqSLCtKNpRs34koENy1VtFDzh+S9e2fezQvypLQuRJG0SALBgBVRutciUTC0dldDoS0qUUSiTfLuOfMS8wKKggHNy505c2OmzI3o828HZjF38bvf+b7zAbScmAwIZSCsGyjOLoEgBoEMgmxbRLYQqdV3SS3D3oaDGDW895Q94AWwuUYQbxfIGyRZiPxV/JlE3lpSGXTMOuhN0nfDImKIiSEkLoSK/bsiyPRL4gGJdpcgloL4iEAeEsQ7/A8EcUFgBtWppddgyuSjnJpQ8E19JQDnx0n7uzCDCmqQZP+SyD/FaKCaLG6SaPrKaEAitwmVK4eYbIt3mK56hRx4H4uUeYXH99V4dy/qwR6VXSyq7Pe4tlTuVsv7BXr1DMPOeX9B+InQtHiHOoc9D+DjMvGRjoTPjzxIm+Mz8+7W6TPJ1MiFudsPF9zAnfsPu9TKzzFxVczyhx6W31agzNPV/q4VZE5UMP1kC7qP/pyuP5mduOWy8atOnz7xjMavuZGbd/6Z+3sM+lB/IYgPR8pCqGwgkV8CBWmIKAWhlj6IyAxX0GzumnEbqpMLN9QvZx+7y5fcSvHr5bGj/U/LD9zItnxU3hMRHwwpg5CWA0GvKNQg0QQSDZSR1wuyB8uJHm2fc6NDV25PJN9927wZhU+//+Pf610N95tM9DmfemdDt5WUF+ND1a8ByYAkDnySgjLv5UBvkn7ZPu8O9ZD9tfueu9zxyLXHtTQWZGMfSmXKBn5DPFC2Alc/MJTIK9RBX23BK/7Bh/TVIwdC2TGJ5mRPw0Efpp/2oq5WktQ3pS0H+pTr9tVd9A2Ja74RXPBLHhGHgviYIB4UaHcK4k5J5seIeDhSdnuU758teCEHphff3pY4sc9H1xDPPAkE8VZJel2EdrXXZDYKMp+XEobiJMOBRvN/uvwCaEDWmzlE5htgC3nNvPlkIKoZCO9qiOfNG5D/ADTpKQDkwaTpAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "components-extra",
            "title": "components-extra",
            "src": "/static/258ea0b98428740d18ce1b2ca04b85c6/2fbbf/logo-introduction.png",
            "srcSet": ["/static/258ea0b98428740d18ce1b2ca04b85c6/0d3e1/logo-introduction.png 140w", "/static/258ea0b98428740d18ce1b2ca04b85c6/908b1/logo-introduction.png 280w", "/static/258ea0b98428740d18ce1b2ca04b85c6/2fbbf/logo-introduction.png 425w"],
            "sizes": "(max-width: 425px) 100vw, 425px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span></p>
      <Introduction mdxType="Introduction" />
    </div>
    <h2>{`Get started`}</h2>
    <h3>{`Prerequisites`}</h3>
    <p>{`Before anything, please make sure to have the three following packages installed:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/react"
        }}>{`react >= 17.0.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/react-dom"
        }}>{`react-dom >= 17.0.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/styled-components"
        }}>{`styled-components >= 5.0.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@material-ui/core"
        }}>{`@material-ui/core >= 4.12.3`}</a></li>
    </ul>
    <h3>{`Step 1`}</h3>
    <p><strong parentName="p">{`components-extra`}</strong>{` relies on both `}<a parentName="p" {...{
        "href": "https://material-ui.com/customization/theming/"
      }}>{`Material-UI's theme`}</a>{` configuration
as well as the `}<a parentName="p" {...{
        "href": "https://www.styled-components.com/docs/advanced"
      }}>{`styled-components`}</a>{` theming system.`}</p>
    <p>{`The first step consists into wrapping your web application in `}<strong parentName="p">{`components-extra`}</strong>{`'s default theme provider `}<inlineCode parentName="p">{`<StyledProvider>`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react'
import { StyledProvider } from 'components-extra'

const App = () => {
  return (
    <StyledProvider>
      <p>Simple, is it not ?</p>
    </StyledProvider>
  )
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` The `}<inlineCode parentName="p">{`StyledProvider`}</inlineCode>{` will forward the `}<strong parentName="p">{`theme`}</strong>{` object to all the children recursively. Not using this Provider above the other components will result in an JS error, and you will not be able to access the theme.`}</p>
    </blockquote>
    <h3>{`Step 2`}</h3>
    <p>{`Import the component you want to use. For example, the `}<inlineCode parentName="p">{`<BackToTop>`}</inlineCode>{` button:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react'
import { BackToTop, StyledProvider } from 'components-extra'

const App = () => {
  return (
    <StyledProvider>
      <BackToTop />
    </StyledProvider>
  )
}
`}</code></pre>
    <p>{`And voilà! you're all set and ready to create your website's interface.`}</p>
    <h2>{`Fonts`}</h2>
    <p>{`Like `}<strong parentName="p">{`Material-UI`}</strong>{`, the components all use `}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://fonts.google.com/specimen/Roboto"
        }}>{`Roboto`}</a></strong>{` font-familly as their main option,
but it is not included in `}<strong parentName="p">{`components-extra`}</strong>{` to provide more freedom to the developers.`}</p>
    <p>{`You have to manually use the following CDN link to include the Roboto font in your application:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
/>
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` adding this `}<inlineCode parentName="p">{`stylesheet`}</inlineCode>{` in the `}<inlineCode parentName="p">{`<head>`}</inlineCode>{` of your page will fetch it in a synchronous way. There are `}<a parentName="p" {...{
          "href": "https://www.filamentgroup.com/lab/load-css-simpler"
        }}>{`multiple techniques`}</a>{` to fetch it asynchronously to improve the performances of your app.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      